import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AppSettings} from '../../../app-settings';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {DataManagementService} from '../../services/data-management.service';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import {Constants} from '../../constants';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-programmes',
  templateUrl: './programmes.component.html',
  styleUrls: ['./programmes.component.css']
})
export class ProgrammesComponent implements OnInit {
  @ViewChild('uploadProgrammesModal') uploadProgrammesModal: TemplateRef<any>;
  @ViewChild('editProgrammeModal') editProgrammeModal: TemplateRef<any>;
  programmesTemplate = AppSettings.PROGRAMME_TEMPLATE;
  public modalReference: NgbModalRef;
  dtTrigger: Subject<string> = new Subject();
  dtOptions: DataTables.Settings = {};
  programmes;
  data: object;
  errorMessage: string = undefined;
  oneProgramme;

  constructor(private modal: NgbModal,
              private dmService: DataManagementService) {
  }

  getProgrammes() {
    this.dmService.getAll(Constants.PROGRAMMES)
        .subscribe(
            response => {
              if (response.status === 'success') {
                this.programmes = response.data;
                if (this.programmes.length === 0) {
                  this.errorMessage = 'There is no data available for programmes.';
                } else {
                    this.dtTrigger.next();
                }
              } else if (response.status === 'fail') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                } else {
                  this.errorMessage = 'Something went wrong. Please contact support team';
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  fileChange(evt) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot upload multiple files on the entry');
    }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, {type: 'binary'});
      /* grab first sheet */
      const wsName = wb.SheetNames[0];
      const ws = wb.Sheets[wsName];
      /* save data */
      this.data = XLSX.utils.sheet_to_json(ws,
          {header: ['name'], range: 1});
    };
    reader.readAsBinaryString(target.files[0]);
    return this.data;
  }

  uploadProgrammes(e) {
    e.preventDefault();
    const finalUploadData = {
      bulk_data: this.data,
      user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
    };
    const that = this;
    let uploadResponse;
    Swal({
      title: 'Confirm',
      type: 'question',
      text: 'You are going to upload ' + Object.keys(this.data).length + ' Programmes?',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#4cb84c',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService.bulkUpload(finalUploadData, Constants.UNIVERSITY).subscribe(data => {
            uploadResponse = data;
            resolve(uploadResponse);
          }, error => {
            uploadResponse = error;
            reject(uploadResponse);
          });
        });
      },
      allowOutsideClick: false
    }).then(function (result) {
      if (result.value === true) {
        if (uploadResponse.status === 'success') {
          if (uploadResponse.data.hasOwnProperty('message')) {
            Swal({
              title: 'Success',
              type: 'success',
              text: uploadResponse.data.message,
            });
          } else {
            Swal({
              title: 'Success',
              type: 'success',
              html: '<p>Successfully uploaded Programmes.</p>',
            });
          }
          that.getProgrammes();
          that.closeModal();
        } else if (uploadResponse.status === 'fail') {
          if (uploadResponse.data.hasOwnProperty('message')) {
            Swal({type: 'error', title: 'Fail', text: uploadResponse.data.message});
          } else {
            Swal({type: 'error', title: 'Fail', text: 'Unable to upload Programmes, Please contact support team.'});
          }
        }
      }
    });
  }

  clearProgrammes(): void {
    Swal({
      title: 'Confirm',
      type: 'question',
      text: 'You are going to Clear Programmes?',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-warning rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#4cb84c',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      showLoaderOnConfirm: true,
    });
  }

  openProgrammesUploadModal() {
    this.modalReference = this.modal.open(this.uploadProgrammesModal, {size: 'lg', backdrop: 'static', keyboard: false});
  }
  closeModal(): void {
    this.modalReference.close();
  }

  ngOnInit() {
    this.getProgrammes();
    this.dtOptions = {
      paging: true,
      retrieve: true,
      destroy: true,
      lengthChange: true,
      info: false
    };
  }

}
